import {Button} from '@wandb/weave/components/Button';
import React from 'react';

import {trackSetting} from '../../services/analytics/workspaceSettingsEvents';
import * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';
import {useSectionSettingsContext} from '../WorkspaceDrawer/Settings/SectionSettingsContextProvider';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawer/WorkspaceDrawerContextProvider';
import {PinSectionButton} from './PinSectionButton';

export type SectionSettingsProps = {
  isPinned: boolean;
  panelBankSectionConfigRef: PanelBankSectionConfigTypes.Ref;
  pinPanelBankSection?: (sectionId: PanelBankSectionConfigTypes.Ref) => void;
  sectionComponentRef: React.RefObject<HTMLDivElement>;
};

export const SectionSettings = ({
  isPinned,
  panelBankSectionConfigRef,
  pinPanelBankSection,
  sectionComponentRef,
}: SectionSettingsProps) => {
  const {contentType, toggleWorkspaceDrawer} = useWorkspaceDrawerContext();
  const {sectionRef: currentSectionRef} = useSectionSettingsContext();

  return (
    <div className="hidden gap-2 md:flex">
      <PinSectionButton
        buttonVariant="ghost"
        isPinned={isPinned}
        panelBankSectionConfigRef={panelBankSectionConfigRef}
        pinPanelBankSection={pinPanelBankSection}
      />
      <Button
        tooltip="Section settings"
        tooltipProps={{
          side: 'bottom',
        }}
        icon="settings"
        variant="ghost"
        aria-label="Section settings"
        onClick={e => {
          toggleWorkspaceDrawer('section-settings', currentSectionRef);
          sectionComponentRef.current?.scrollIntoView({
            block: 'start',
            inline: 'start',
            behavior: 'smooth',
          });

          if (contentType == null) {
            trackSetting({
              action: 'open section drawer',
              page: 'workspace',
            });
          }
          e.stopPropagation();
        }}
      />
    </div>
  );
};
